import React from 'react'

const Header = () => {
    return (
        <header>
            <p> Weather Forecast</p>
        </header>
    );
};

export default Header;